import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import colorShader from 'src/lib/colorShader';
import Button from './Button';

const Wrapper = styled.div`
  ${({ isInverted, theme: { colors } }) =>
    css`
      a {
        border-radius: 2px;
        transition: color 0.2s, background-color 0.2s;
        width: 120px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid ${colors.defaultActionBlue};
        color: ${isInverted ? colors.white : colors.defaultActionBlue};
        background-color: ${isInverted
          ? colors.defaultActionBlue
          : colors.white};
        font-size: ${({ theme }) => theme.utils.pxToRem(12)}rem;

        &:hover {
          color: ${colors.white};
          background-color: ${colorShader(0.12, colors.defaultActionBlue)};
        }
      }
    `}
`;

// This component is necessary because you can't make Link accept special props without react complaining (because it's just an <a>)
export default class NavButton extends PureComponent {
  render() {
    const { to, children, ...otherProps } = this.props;

    return (
      <Wrapper {...otherProps}>
        <Link to={to}>{children}</Link>
      </Wrapper>
    );
  }
}
